import { Salutation } from '@coldtec/cos-types';
import { RequestState } from './request.types';

/**
 *  Holding the state of the products.
 */
export const State: { request: RequestState; } = {
    request: {
        valid: false,
        guid: null,
        data: {
            spaces: [],
            additional_products: [],
            service_products: [],
            client: {
                salutation: Salutation.Unknown,
                first_name: '',
                last_name: '',
                phone_number: '',
                email_address: '',
            },
            address: {
                streetname: '',
                house_number: '',
                zipcode: '',
                city: '',
            },
            remarks: null,
            terms_and_conditions: 0,
            privacy_statement: 0,
            requested_installation: 0,
            preferred_installation_date: null,
        },
    },
};
